import React, { useEffect, useRef, useState } from "react";
import { BookUser, Search } from "lucide-react";
import { api } from "../../lib/api";
import { Input } from "../ui/input";

const CLIENT_KEYS = ["name", "email", "phone", "vat", "type", "address", "address_street", "address_number", "address_zip", "address_city", "address_province"];

export default function ClientPicker({ onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => {
      api.get("/clients", { params: { q } }).then(({ data }) => setRows(data.slice(0, 8))).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [q, open]);

  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const pick = (c) => {
    onPick(Object.fromEntries(CLIENT_KEYS.map((k) => [k, c[k] || (k === "type" ? "business" : "")])));
    setOpen(false);
    setQ("");
  };

  return (
    <div ref={box} className="relative mb-5" data-testid="client-picker">
      <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
      <Input data-testid="client-picker-input" value={q} onFocus={() => setOpen(true)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        placeholder="Cerca in rubrica per nome, email o P.IVA" className="pl-9" />
      {open && (
        <div data-testid="client-picker-results" className="absolute z-30 mt-1 w-full rounded-lg border border-slate-200 bg-card shadow-lg max-h-72 overflow-auto">
          {rows.length === 0 && <p className="px-3 py-3 text-sm text-slate-500">Nessun cliente in rubrica{q ? " per questa ricerca" : ""}.</p>}
          {rows.map((c) => (
            <button key={c.id} type="button" data-testid={`client-picker-option-${c.id}`} onClick={() => pick(c)}
              className="w-full text-left px-3 py-2 hover:bg-slate-50 flex items-start gap-2 border-b border-slate-100 last:border-0">
              <BookUser className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" />
              <span className="min-w-0">
                <span className="block text-sm font-medium text-slate-900 truncate">{c.name}</span>
                <span className="block text-xs text-slate-500 truncate">{[c.email, c.address].filter(Boolean).join(" · ")}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
